var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg51(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.31,
    cy: 23.61,
    fill: "#7BC8FF",
    rx: 19.49,
    ry: 19.59
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#043582",
    d: "M11.14 23.27l-2.75 3.28a9.8 9.8 0 0 0 4.64 4.66c1.01-.82 2.3-1.93 3.32-2.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#073984",
    d: "M28.35 20.68v4.82a13 13 0 0 1-3.77 9.15l-4.72 4.74-.6-11.63 9.09-7.08zm-9.32-9.44l-5.01-.15a12.8 12.8 0 0 0-9.1 3.8L.18 19.62l11.57.6 7.27-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.36 21.96a17.93 17.93 0 0 0 7.14 7.18l13.02-10.16a23.52 23.52 0 0 0 9.02-17.4l.01-.4a1.04 1.04 0 0 0-1.12-1.1l-.75.04a23.33 23.33 0 0 0-16.64 8.63L10.36 21.96z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.86,
    cy: 11.07,
    fill: "#073984",
    rx: 4.15,
    ry: 4.17
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.75,
    cy: 18.87,
    fill: "#073984",
    rx: 2.07,
    ry: 2.08
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#043582",
    d: "M12.1 28.12l-8.36 5.8c1.5 2.42 3.51 4.5 5.88 6.06l5.86-8.48a9.63 9.63 0 0 1-3.37-3.38z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg51);
export default __webpack_public_path__ + "static/media/5.1.6f975aa692b741fdcbad007844f9d82d.svg";
export { ForwardRef as ReactComponent };